import { notifyMessage } from '../constants/notify-message';

type Context = 'update-survey' | 'clone-survey';

export class InactiveQualificationsMessageComposer<
  T extends { qualification_name: string }
> {
  constructor(
    private readonly _qualifications: T[] = [],
    private readonly _context: Context = 'update-survey'
  ) {}

  public compose(): string {
    if (!this._qualifications || !this._qualifications.length) {
      return '';
    }

    const baseMessage =
      this._context === 'clone-survey'
        ? notifyMessage.warningMessage.INACTIVE_QUALIFICATION.SURVEY_CLONE
        : notifyMessage.warningMessage.INACTIVE_QUALIFICATION.SURVEY_UPDATE;
    return baseMessage.replace('<INACTIVE_QUAL_LIST>', this._bulletPointList());
  }

  private _bulletPointList(): string {
    return this._qualifications.reduce(
      (resultingString, currentQualification, index) => {
        return `
            ${resultingString}
            &nbsp;&nbsp;-&nbsp; ${currentQualification.qualification_name}
            ${index < this._qualifications.length - 1 ? '<br>' : ''}`;
      },
      ''
    );
  }
}
